export default __webpack_public_path__ + "static/media/logo1.5229ff1b.png";